import { SnackbarProvider } from 'notistack';

import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation, faInfo } from '@fortawesome/free-solid-svg-icons';

import { CerebroIcon } from '../components';
import { weights, fontFamily } from './CerebroThemeProvider';

// @ts-ignore
const useStyles = makeStyles((theme: Theme) => ({
	success: {
		backgroundColor: `${theme.palette.primary.main} !important`,
		color: `${theme.palette.primary.contrastText} !important`,
		fontSize: '14px !important',
		lineHeight: '18px !important',

		fontWeight: `${weights.semibold} !important`,
		fontFamily: `${fontFamily} !important`,
	},

	info: {
		backgroundColor: `${theme.palette.info.light} !important`,
		color: `${theme.palette.info.contrastText} !important`,
		fontSize: '14px !important',
		lineHeight: '18px !important',

		fontWeight: `${weights.semibold} !important`,
		fontFamily: `${fontFamily} !important`,
	},

	error: {
		backgroundColor: `${theme.palette.error.main} !important`,
		color: `${theme.palette.error.contrastText} !important`,
		fontSize: '14px !important',
		lineHeight: '18px !important',

		fontWeight: `${weights.semibold} !important`,
		fontFamily: `${fontFamily} !important`,
	},
}));

export const CerebroSnackbarProvider: React.FC = ({ children }) => {
	const styles = useStyles();

	return (
		<SnackbarProvider
			maxSnack={3}
			anchorOrigin={{
				horizontal: 'right',
				vertical: 'top',
			}}
			classes={{
				variantSuccess: styles.success,
				variantInfo: styles.info,
				variantError: styles.error,
				variantWarning: styles.error,
			}}
			iconVariant={{
				success: (
					<CerebroIcon padRight>
						<FontAwesomeIcon icon={faCheck} size="lg" />
					</CerebroIcon>
				),
				info: (
					<CerebroIcon padRight>
						<FontAwesomeIcon icon={faInfo} size="lg" />
					</CerebroIcon>
				),
				error: (
					<CerebroIcon padRight>
						<FontAwesomeIcon icon={faExclamation} size="lg" />
					</CerebroIcon>
				),
			}}
		>
			{children}
		</SnackbarProvider>
	);
};
